import {NativeDateAdapter} from '@angular/material/core';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomDateTimeAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }

  override getDayOfWeekNames(): string[] {
    return ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  }

  override getMonthNames(): string[] {
    return ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
      'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  }

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === 'HH:mm') {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    }

    const day = this.convertToTwoSymbols(date.getDate());
    const month = this.convertToTwoSymbols(date.getMonth() + 1);

    return `${day}.${month}.${date.getFullYear()}`;
  }

  private convertToTwoSymbols(value: number): string {
    const stringValue = String(value);
    const valueLength = stringValue.length;

    return valueLength > 1 ? stringValue : `0${stringValue}`;
  }

  override parse(value: any): Date | null {
    if (!value) { return null; }

    if (typeof value === 'string') {
      const timeMatch = value.match(/^(\d{1,2})[:.](\d{2})$/);
      if (timeMatch) {
        const hours = parseInt(timeMatch[1], 10);
        const minutes = parseInt(timeMatch[2], 10);
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
          const now = new Date();
          return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
        }
      }

      const dateParts = value.split('.');
      if (dateParts.length === 3) {
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1;
        let year = parseInt(dateParts[2], 10);
        if (year < 100) {
          year += 2000;
        }

        return new Date(year, month, day);
      }
    }

    return super.parse(value);
  }
}
